import Cookies from 'js-cookie'
import Module from '../lib/module'

@Module.define('cookieConsent')
class CookieConsentModule extends Module {
	constructor(options) {
		super(options)

		this.config = (window.LMC && window.LMC.cookieConsent) || {}
		this.cookieName = this.config.cookieName || 'lmc_cookie_consent'
		this.valueAnalytics = this.config.valueAnalytics || 'analytics'
		this.valueEssential = this.config.valueEssential || 'essential'
		this.lifetimeDays = this.config.lifetimeDays || 365
		this.banner = document.getElementById('js-cookie-consent')
		this.gpcNotice = document.getElementById('js-cookie-consent-gpc')
		this.acceptBtn = document.querySelector('.js-cookie-consent-accept')
		this.rejectBtn = document.querySelector('.js-cookie-consent-reject')
		this.preferencesTriggers = document.querySelectorAll('.js-cookie-preferences')
		this.trackingLoaded = false
	}

	main() {
		const required = this.config.required === true || this.config.required === 'true'

		// Authenticated members: tracking already loaded server-side; no banner.
		if (!required) {
			return
		}

		if (this.hasGpc()) {
			this.applyEssentialFromGpc()
			return
		}

		const consent = Cookies.get(this.cookieName)

		if (consent === this.valueAnalytics) {
			this.loadTracking()
			this.hideBanner()
			return
		}

		if (consent === this.valueEssential) {
			this.hideBanner()
			return
		}

		this.showBanner()
	}

	bindEvents() {
		if (this.acceptBtn) {
			this.acceptBtn.addEventListener('click', (e) => {
				e.preventDefault()
				this.acceptAnalytics()
			})
		}

		if (this.rejectBtn) {
			this.rejectBtn.addEventListener('click', (e) => {
				e.preventDefault()
				this.rejectNonEssential()
			})
		}

		this.preferencesTriggers.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault()
				this.showBanner()
				if (this.gpcNotice) {
					this.gpcNotice.hidden = true
				}
			})
		})
	}

	hasGpc() {
		return typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true
	}

	setConsentCookie(value) {
		Cookies.set(this.cookieName, value, {
			expires: this.lifetimeDays,
			path: '/',
			sameSite: 'Lax'
		})
	}

	applyEssentialFromGpc() {
		this.setConsentCookie(this.valueEssential)
		this.hideBanner()
		if (this.gpcNotice) {
			this.gpcNotice.hidden = false
			window.setTimeout(() => {
				if (this.gpcNotice) {
					this.gpcNotice.hidden = true
				}
			}, 8000)
		}
	}

	acceptAnalytics() {
		// Global Privacy Control must be honored; do not allow opt-in while GPC is set.
		if (this.hasGpc()) {
			this.applyEssentialFromGpc()
			return
		}
		this.setConsentCookie(this.valueAnalytics)
		this.loadTracking()
		this.hideBanner()
	}

	rejectNonEssential() {
		this.setConsentCookie(this.valueEssential)
		this.hideBanner()
	}

	showBanner() {
		if (this.banner) {
			this.banner.hidden = false
			this.banner.setAttribute('aria-hidden', 'false')
		}
	}

	hideBanner() {
		if (this.banner) {
			this.banner.hidden = true
			this.banner.setAttribute('aria-hidden', 'true')
		}
	}

	loadTracking() {
		if (this.trackingLoaded) {
			return
		}
		this.trackingLoaded = true

		const gtmId = this.config.gtmId || 'GTM-KS6ZFW3'
		this.injectGtm(gtmId)
		this.injectKenticoActivity()
	}

	injectGtm(gtmId) {
		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({
			event: 'gtm.js',
			'gtm.start': new Date().getTime()
		})
		window.dataLayer.push({
			event: 'consent_update',
			analytics_storage: 'granted'
		})

		const script = document.createElement('script')
		script.async = true
		script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
		const firstScript = document.getElementsByTagName('script')[0]
		if (firstScript && firstScript.parentNode) {
			firstScript.parentNode.insertBefore(script, firstScript)
		} else {
			document.head.appendChild(script)
		}

		if (!document.getElementById('js-gtm-noscript')) {
			const noscript = document.createElement('noscript')
			noscript.id = 'js-gtm-noscript'
			const iframe = document.createElement('iframe')
			iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`
			iframe.height = '0'
			iframe.width = '0'
			iframe.style.display = 'none'
			iframe.style.visibility = 'hidden'
			noscript.appendChild(iframe)
			document.body.insertBefore(noscript, document.body.firstChild)
		}
	}

	injectKenticoActivity() {
		const template = document.getElementById('js-kentico-activity-template')
		if (!template || !template.content) {
			return
		}

		const scripts = template.content.querySelectorAll('script')
		scripts.forEach((oldScript) => {
			const newScript = document.createElement('script')
			Array.from(oldScript.attributes).forEach((attr) => {
				newScript.setAttribute(attr.name, attr.value)
			})
			if (oldScript.src) {
				newScript.src = oldScript.src
			} else {
				newScript.textContent = oldScript.textContent
			}
			document.body.appendChild(newScript)
		})
	}
}

export default CookieConsentModule
